import React from 'react'

export default function MainLayoutPage(props) {
    return (
        <div>
            <div className="main-container">
                <div className="nav-section">

                    <div className="nav-section-for-collapse">
                        <div className="navbar-brand">Welcome to the PCRB/DCRB
                            <br/>
                            Correspondence Manager
                        </div>                                                   
                    </div>
                    {props.navControls}
                </div>
                <div className="user-home-page-content">
                        {props.contentArea}
                </div>
                    
            </div>
        </div>
    )
}
